
(function() {

    'use strict';
    angular.module('app')
        .service('clientService',
            [
                '$http', function ($http) {

                    this.getClients = function() {
                        return $http.get('api/client/getclients')
                            .then(function(response) {
                                    return response.data;
                                },
                                function() {
                                    throw ('Restricted Logins Failure');
                                });

                    };

                    

                }
            ]
        );
})();